














import { Component, Vue, Prop } from "vue-property-decorator";
import { AppConstants } from "@/core/Export";
import store from "@/store";

@Component({
  components: {},
})
export default class AdditionIcon extends Vue {
  @Prop() props: any;
  @Prop() isCurrentUserAdditional: boolean;

  constructor() {
    super();
  }
  
  openAdditionalDrawer() {
    store.commit(AppConstants.StoreMutations.UpdateDrawerParams, {
      date: this.props.date,
      employeeId: this.props.employeeId,
      isCurrentUserAdditional: this.isCurrentUserAdditional
    });
    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, true);
    store.commit(
      AppConstants.StoreMutations.UpdateLeftDrawerComponnent,
      AppConstants.DrawerComponnents.Additions
    );
  }
}
